module.exports = __webpack_public_path__ + "img/ban04_img.06a14e36.png";